/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EventManagementSettingEventEditRequest = {
    id: number;
    winnerStatus?: EventManagementSettingEventEditRequest.winnerStatus;
    eventNumber?: number;
    finalPrice?: number;
};

export namespace EventManagementSettingEventEditRequest {

    export enum winnerStatus {
        RELEASE = 'release',
        SOLDOUT = 'soldout',
        CANCEL = 'cancel',
    }


}

